import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface MakeupBalanceSlice {
  limit: number;
  used: number;
  remaining: number;
  isOverride: boolean;
}

export interface MakeupBalances {
  studioId: string;
  sessionId: string;
  parentId: string;
  studentId: string;
  family: MakeupBalanceSlice;
  student: MakeupBalanceSlice;
}

export const getMakeupBalancesAPI = async (params: {
  studentId: string;
  sessionId: string;
}) => {
  const response = await baseAPI.get<MakeupBalances>('/makeup/balances', {
    params,
  });
  return response.data;
};

export const useGetMakeupBalances = (
  params: { studentId: string; sessionId: string },
  enabled = true,
) => {
  return useQuery({
    queryKey: [KEYS.MAKEUP_BALANCES, params.studentId, params.sessionId],
    queryFn: () => getMakeupBalancesAPI(params),
    enabled: enabled && !!params.studentId && !!params.sessionId,
  });
};
